module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"Ja":"Yes","Avbryt":"Cancel"},"sv":{"Ja":"Ja","Avbryt":"Avbryt"}}')
  delete Component.options._Ctor
}
